import { useOutletContext } from "react-router";
import { useSettingsStore } from "../stores/settingsStore";

export const Settings = () => {
	const { persistence } = useOutletContext<any>();
	const { enterIsSend, richTextToolbar, audibleNotifications, messageRequests, setSettings } =
		useSettingsStore();

	const update = (key: string, value: string | boolean) => {
		persistence?.set(`config#${key}`, "" + value);
		setSettings({ [key]: value } as any);
	};

	return (
		<div className="flex flex-col h-full p-6 max-w-lg mx-auto overflow-y-auto">
			<h1 className="text-xl font-semibold text-white mb-6">Settings</h1>

			<div className="glass-panel rounded-2xl divide-y divide-white/8">
				{/* Enter is send */}
				<div className="flex items-center justify-between px-5 py-4">
					<div>
						<p className="text-sm font-medium text-white">Send with Enter</p>
						<p className="text-xs text-white/50 mt-0.5">Press Shift+Enter for new line</p>
					</div>
					<button
						role="switch"
						aria-checked={enterIsSend}
						onClick={() => update("enterIsSend", !enterIsSend)}
						className={`w-11 h-6 rounded-full transition-colors relative ${
							enterIsSend ? "bg-primary" : "bg-white/20"
						}`}
					>
						<span className={`absolute top-1 w-4 h-4 rounded-full bg-white transition-all ${
							enterIsSend ? "left-6" : "left-1"
						}`} />
					</button>
				</div>

				{/* Audible notifications */}
				<div className="flex items-center justify-between px-5 py-4">
					<div>
						<p className="text-sm font-medium text-white">Sound notifications</p>
						<p className="text-xs text-white/50 mt-0.5">Play sound for incoming messages</p>
					</div>
					<button
						role="switch"
						aria-checked={audibleNotifications}
						onClick={() => update("audibleNotifications", !audibleNotifications)}
						className={`w-11 h-6 rounded-full transition-colors relative ${
							audibleNotifications ? "bg-primary" : "bg-white/20"
						}`}
					>
						<span className={`absolute top-1 w-4 h-4 rounded-full bg-white transition-all ${
							audibleNotifications ? "left-6" : "left-1"
						}`} />
					</button>
				</div>

				{/* Message requests */}
				<div className="px-5 py-4">
					<p className="text-sm font-medium text-white mb-3">Message requests</p>
					{["spam", "strangers", "invites"].map((value) => (
						<label key={value} className="flex items-center gap-3 py-1 cursor-pointer">
							<div className={`w-4 h-4 rounded-full border-2 flex items-center justify-center ${
								messageRequests === value ? "border-primary" : "border-white/30"
							}`}>
								{messageRequests === value && (
									<div className="w-2 h-2 rounded-full bg-primary" />
								)}
							</div>
							<input
								type="radio"
								name="messageRequests"
								value={value}
								checked={messageRequests === value}
								onChange={() => update("messageRequests", value)}
								className="sr-only"
							/>
							<span className="text-sm text-white/80 capitalize">{value}</span>
						</label>
					))}
				</div>
			</div>
		</div>
	);
};
